var TopicInfoSerialiser = require('topics/details/topic-info-serialiser');
var SubscriptionNotification = require('./subscription-notification');

module.exports = {
    read : function(input) {
        var info = TopicInfoSerialiser.read(input);
        return new SubscriptionNotification(info);
    },
    write : function(out, notification) {
        TopicInfoSerialiser.write(out, notification.info);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/subscription-notification/subscription-notification-serialiser.js
// module id = 1702
// module chunks = 1